<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="经销商:">
              <el-input v-model.trim="formInlineTmp.dealer" placeholder="请输入经销商名称" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="formInlineTmp.status" placeholder="请选择">
                <el-option v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <el-table-column label="经销商">
          <template slot-scope="scope">
            {{ scope.row.dealer_name }}
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            {{ scope.row.amount }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if=" scope.row.status === 1" style="color:blue">未审核</span>
            <span v-if=" scope.row.status === 2" style="color:green">通过审核</span>
            <span v-if=" scope.row.status === 3" style="color:darkred">未通过审核</span>
          </template>
        </el-table-column>
        <el-table-column label="审核时间">
          <template slot-scope="scope">
            <span v-if=" scope.row.status !== 1">{{ scope.row.examine_time_text }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1" class="op-link" @click="editAction(scope.row.id, 2)">
              通过审核
            </div>
            <div v-if="scope.row.status === 1" class="op-link" @click="editAction(scope.row.id, 3)">
              不通过审核
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getYxAccountList, approveYxAccountApprove } from '@/api/yunxiao.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
      formInlineTmp:{},
      formInline: {
        title:'',
      },
      options: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '审核中'
        },
        {
          value: '2',
          label: '通过'
        },
        {
          value: '3',
          label: '失败'
        },
      ],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getYxAccountList(this.page, this.limit, 2, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 删除
    editAction(id, status) {
      let str = '审核通过'
      if(status == 2){
        str = '[通过审核]'
      }
      else if(status == 3){
        str = '[不通过审核]'
      }
      else{
        return
      }
      this.$confirm('确认此信息' + str + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        approveYxAccountApprove(id, status).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '操作成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>

</style>
